import { useEffect, useState } from 'react';

import { Theme, useMediaQuery } from '@mui/material';
import store from 'store';

import useDateQuery from '@common/helpers/useDateQuery';
import useModel from '@common/helpers/useModel';
import useDateRangeQuery from '@common/helpers/useRangeDateQuery';
import StudentGrades, {
	type IStudentGradesModel,
} from '@common/models/StudentGrades/StudentGrades';
import { IStudentSimpleProgramModel } from '@common/models/StudentPrograms/StudentSimpleProgram';

export default (isCalendarView: boolean) => {
	const showMonthVersion = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));

	const { startDate, endDate, startDateTime, endDateTime } = useDateRangeQuery();

	const { dateTime, setDateTime, date } = useDateQuery();
	const [selectedPrograms, setSelectedPrograms] = useState<IStudentSimpleProgramModel[]>([]);

	const onProgramChange = (value: IStudentSimpleProgramModel[]) => {
		setSelectedPrograms(value);
	};

	const studentGrades = useModel(
		StudentGrades,
		{
			service_id: store.services.current.id,
			studentId: store.currentStudentId,
			...(isCalendarView
				? {
						period_start: dateTime.startOf(showMonthVersion ? 'month' : 'week').toISODate(),
						period_end: dateTime.endOf(showMonthVersion ? 'month' : 'week').toISODate(),
					}
				: {
						period_start: startDateTime.toISODate(),
						period_end: endDateTime.toISODate(),
					}),
		},
		[selectedPrograms, date, startDate, endDate, store.currentStudentId],
		{
			disableFetch: true,
		},
	) as IStudentGradesModel;

	useEffect(() => {
		if (selectedPrograms?.length) {
			const value = selectedPrograms.map((program) => program.program_group_id);
			studentGrades.fetch(value);
		}
	}, [selectedPrograms, date, startDate, endDate, store.currentStudentId]);

	return {
		studentGrades,
		onProgramChange,
		selectedPrograms,
		dateTime,
		setDateTime,
	};
};
